import React from 'react';
import Style from './style.module.scss';

const PageHeader = ({ title }) => {
  return (
    <div className={Style.header}>
      <video autoPlay muted loop playsInline className={Style.video}>
        <source src="./assets/video/mobilebg.mp4" type="video/mp4" />
      </video>
      <h1 className={Style.title}>{title}</h1>
    </div>
  );
};

export default PageHeader;
